// removed by extract-text-webpack-plugin
module.exports = {"category-header":"category-header","header-title":"header-title"};


//////////////////
// WEBPACK FOOTER
// ./pages/sub-categories/_CategoryHeader.scss
// module id = ./pages/sub-categories/_CategoryHeader.scss
// module chunks = 0